/**
 * A descrição do atendimento como TEXTO.
 *
 * O SGA guarda a descrição em HTML (`<p><strong>…</strong></p>`, medido em
 * 14/10/2026 na CE), e a tela mostrava as marcas cruas. Ela é lida aqui como
 * documento — `DOMParser`, que não executa nada — e devolvida só com o texto,
 * com parágrafo e quebra de linha virando linha. O dado continua como o SGA o
 * mandou no núcleo; a conversão é da tela.
 *
 * Mora em `lib/` desde 21/10/2026, quando a Agenda de clientes passou a mostrar
 * o atendimento também: um módulo da interna não importa do outro.
 */
export function plainText(html: string): string {
  if (!/[<&]/.test(html)) return html;
  const marked = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6])>/gi, '\n');
  const text =
    new DOMParser().parseFromString(marked, 'text/html').body.textContent ?? '';
  return text.replace(/\n{3,}/g, '\n\n').trim();
}
